import { BoxProps, ColorOptions, convertHexToRGBA, ImageProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { isMobileWidth, isTabletWidth } from '../../util/util'

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)

  // const responsivePadding = getPadding(breakpoint)
  return {
    consumer: {
      content: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        minHeight: isMobile || isTab ? '50vh' : undefined,
        ph: responsivePadding,
        justifyContent: 'flex-start',
        paddingTop: isMobile ? 80 : 108,
        height: '100%',
      } as BoxProps,
      footerBox: {
        flexDirection: 'column',
        marginRight: isMobile ? 0 : isTab ? 16 : 50,
        marginBottom: isMobile || isTab ? 80 : 120,
        width: isMobile ? undefined : isTab ? '33%' : '35%',
        minWidth: isTab ? 130 : 150,
      } as BoxProps,
      imgBox: {
        marginRight: isMobile ? 0 : isTab ? 16 : 50,
        marginBottom: isMobile ? 72 : 40,
        width: isMobile ? '100%' : isTab ? '36%' : '25%',
        minWidth: isTab ? 150 : 250,
        flexDirection: 'row',
        align: 'center',
        h: 42,
      } as BoxProps,
      imageBrackets: {
        position: 'relative',
        zIndex: 10,
        left: '-10%',
        top: '40%',
      } as ViewStyle,
      imageBracketsDim: {
        height: 100,
        width: 100,
      } as ViewStyle,
      image: {
        width: 112,
        height: 56,
      } as ImageProps,
      imageLogo: {
        width: 104,
        height: 52,
      } as ViewStyle,
      imageMargin: {
        marginLeft: 0,
        marginBottom: 30,
      } as BoxProps,
      stringMargin: {
        bg: convertHexToRGBA('#ffffff', 30) as ColorOptions,
        borderRadius: 24,
        justify: 'center',
        ph: 16,
        flexDirection: 'column',
      } as BoxProps,
      headerText: {
        fontSize: 16,
        fontFamily: 'jiotype-medium',
        letterSpacing: -0.32,
        lineHeight: 36,
        textAlign: 'left',
        color: 'WHITE',
      } as TextProps,
      titletextBox: {
        pl: 16,
      } as BoxProps,
      bgHeader: {
        width: 24,
        marginTop: isMobile ? 8 : 12,
        height: 2,
        borderRadius: 16,
        backgroundColor: 'BLACK',
        display: 'none',
      } as BoxProps,
      containerView: {
        alignItems: 'center',
        pv: 36,
        display: 'none',
      } as BoxProps,
      imageView: {
        height: 24,
        width: isMobile ? 250 : 380,
      } as ImageProps,
    },
    business: {
      content: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        minHeight: isMobile || isTab ? '50vh' : undefined,
        ph: responsivePadding,
        justifyContent: 'flex-start',
        paddingTop: isMobile ? 80 : 140,
        height: '100%',
      } as BoxProps,
      footerBox: {
        flexDirection: 'column',
        marginRight: isMobile ? 0 : isTab ? 16 : 50,
        marginBottom: isMobile || isTab ? 80 : 120,
        width: isMobile ? undefined : isTab ? '33%' : '35%',
        minWidth: isTab ? 130 : 150,
      } as BoxProps,
      imgBox: {
        marginRight: isMobile ? 0 : isTab ? 16 : 50,
        marginBottom: isMobile ? 16 : 40,
        width: isMobile ? '100%' : isTab ? '36%' : '25%',
        minWidth: isTab ? 150 : 250,
        flexDirection: 'row',
        align: 'center',
        h: 42,
      } as BoxProps,
      imageBrackets: {
        position: 'relative',
        zIndex: 10,
        left: '-10%',
        top: '40%',
      } as ViewStyle,
      imageBracketsDim: {
        height: 100,
        width: 100,
      } as ViewStyle,
      image: {
        width: 42,
        height: 42,
      } as ImageProps,
      imageLogo: {
        width: 104,
        height: 52,
      } as ViewStyle,
      imageMargin: {
        marginLeft: 0,
        marginBottom: 30,
      } as BoxProps,
      stringMargin: {
        marginLeft: 0,
      } as BoxProps,
      headerText: {
        fontSize: 'MEDIUM',
        fontFamily: 'jiotype-bold',
        color: 'BLACK',
      } as TextProps,
      titletextBox: {
        pl: 0,
      } as BoxProps,
      bgHeader: {
        width: 24,
        marginTop: isMobile ? 8 : 12,
        height: 2,
        borderRadius: 16,
        backgroundColor: 'BLACK',
      } as BoxProps,
      containerView: {
        alignItems: 'center',
        pv: 36,
      } as BoxProps,
      imageView: {
        height: 24,
        width: isMobile ? 250 : 380,
      } as ImageProps,
    },
  }
}
